import React from "react"
import PropTypes from "prop-types"
import { Box } from "@material-ui/core"
import { ToggleButtonGroup } from "@material-ui/lab"
import { fieldPropTypes } from "redux-form"
import { ON_BLUR_CALL_DELAY } from "../../commons/utils"

const FieldScale = ({
  children,
  type,
  label,
  placeholder,
  readonly,
  input: { onChange, onBlur, value },
  ...custom
}) => (
  <Box textAlign="center">
    <ToggleButtonGroup
      exclusive
      size="large"
      style={{
        height: 100,
        width: "100%",
        justifyContent: "center"
      }}
      {...custom}
      value={value}
      onChange={(_, newValue) => {
        onChange(newValue)

        // Since the selector is never really on "focus", this is the best alternative.
        // NOTE: Without setTimeout, the onBlur would be called BEFORE the value changes.
        setTimeout(onBlur, ON_BLUR_CALL_DELAY)
      }}
    >
      {children}
    </ToggleButtonGroup>
  </Box>
)

FieldScale.propTypes = {
  ...fieldPropTypes,
  type: PropTypes.string.isRequired
}

export default FieldScale
